var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7555 9.92L5.74448 21.6H0V16.43L13.0111 4.72L18.7555 9.93001V9.92ZM23.7222 5.42L20.9889 7.88L15.2445 2.71001L17.9444 0.25C18.0444 0.18 18.1555 0.120007 18.2778 0.0700073C18.4 0.0200073 18.5222 0 18.6444 0C18.8 0 18.9333 0.0200073 19.0556 0.0700073C19.1778 0.120007 19.2667 0.18 19.3444 0.25L23.7222 4.15001C23.8 4.24001 23.8667 4.34001 23.9222 4.45001C23.9778 4.56001 24 4.67 24 4.78C24 4.92 23.9778 5.04001 23.9222 5.15001C23.8667 5.26001 23.8 5.36001 23.7222 5.45001V5.41V5.42Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.f42103a8dd6b616637949cb8aa505e1b.svg";
export { ForwardRef as ReactComponent };